import React from 'react';

import BoardSizeInline from 'shared/components/parameters/BoardSizeInline';
// import BoardSizeTwoCols from 'shared/components/BoardSizeTwoCols';

const BoardSize = (props) => {
  const { template } = props;

  if (template === 'inline') {
    return <BoardSizeInline {...props} />;
  }

  return null;
  // return <BoardSizeTwoCols {...props} />;
};

BoardSize.defaultProps = {
  groupName: 'parameters',
  boardSizerequired: false,
  label: Spree.translations.parameters.board_size,
  labelLength: Spree.translations.parameters.board_length,
  labelWidth: Spree.translations.parameters.board_width,
  tooltip: Spree.translations.helps.board_size,
  tooltipLength: Spree.helpForParameters.board_length,
  tooltipWidth: Spree.helpForParameters.board_width,
  template: 'inline',
};

export default BoardSize;
